import React from "react";
import WebMapSelect from "@components/ArcGIS/WebMapSelect";
import styled from "styled-components";

const MapsContainer = styled.div`
	width: 100%;
	height: 100%;
	margin-bottom: 3em;

	@media (max-width: 430px) {
		header {
			font-size: 0.9em;
			text-align: center;
		}

		select {
			font-size: 0.8em;
		}
	}
`;

const DistrictMaps = ({ maps, additionalMapsLink }) => {
	return (
		<MapsContainer>
			<WebMapSelect
				maps={maps}
				header={"2021 District Maps"}
				footer={
					<div className="container-fluid h-100 d-flex flex-row align-items-center justify-content-center">
						{additionalMapsLink}
					</div>
				}
			/>
		</MapsContainer>
	);
};

export default DistrictMaps;
